<template>
  <div>
      <ToolsBar :viewColidee="viewColidee" :window="window" :sondageName="sondageName"/>
      <SliderResultats :window="window" v-if="this.sondage_vue_resultats === 'slider' && type_formulaire === 'simple'" />
      <SliderResultatsSection :window="window" v-if="this.sondage_vue_resultats === 'slider' && type_formulaire === 'section'" />
      <AllResultats :window="window" v-if="this.sondage_vue_resultats === 'all' && type_formulaire === 'simple'" />
      <AllResultatsSection :window="window" v-if="this.sondage_vue_resultats === 'all' && type_formulaire === 'section'" />
  </div>
</template>

<script>
import AllResultats from '@/components/resultats/AllResultats'
import AllResultatsSection from '@/components/resultats/section/AllResultatsSection'
import LibreResultats from '@/components/resultats/LibreResultats'
import SliderResultats from '@/components/resultats/SliderResultats'
import SliderResultatsSection from '@/components/resultats/section/SliderResultatsSection'
import ToolsBar from '@/components/resultats/components/ToolsBar'
import { mapGetters } from 'vuex'

export default {
  name: 'ContentResultats',
  props: {
    sondageName: {
      required: true,
      type: String
    },
    viewColidee: {
      required: false
    },
    window: {
      required: false
    }
  },
  components: {
    SliderResultats,
    AllResultats,
    LibreResultats,
    AllResultatsSection,
    SliderResultatsSection,
    ToolsBar
  },
  computed: {
    ...mapGetters(['sondage_vue_resultats', 'sondage_vue_type_resultats', 'configure_questions_sondage', 'type_formulaire'])
  },
  updated () {
    let message = {
      height: document.body.scrollHeight
    }
    window.top.postMessage(message, '*')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/resultats/ContentResultats.vue